module.exports = __webpack_public_path__ + "img/shangye_lanzhouxizhan_suoluetu.06d033e8.png";